import React from 'react';

// Minimal line-icon set (24x24, stroke-based) used across the site.
const paths = {
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" />,
  arrowLeft: <path d="M19 12H5M11 18l-6-6 6-6" />,
  arrowUpRight: <path d="M7 17 17 7M8 7h9v9" />,
  code: <path d="m8 7-5 5 5 5M16 7l5 5-5 5M14 4l-4 16" />,
  mobile: (
    <>
      <rect x="6" y="2.5" width="12" height="19" rx="3" />
      <path d="M11 18.5h2" />
    </>
  ),
  cloud: <path d="M7 18.5a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18 8.5a4.5 4.5 0 0 1-.5 10H7Z" />,
  compass: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" />
    </>
  ),
  zap: <path d="M13 2.5 4 14h7l-1 7.5L19 10h-7l1-7.5Z" />,
  shield: (
    <>
      <path d="M12 21.5s-8-3.5-8-10V5l8-2.5L20 5v6.5c0 6.5-8 10-8 10Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  layers: <path d="m12 3 9 5-9 5-9-5 9-5ZM3 13l9 5 9-5M3 17.5l9 5 9-5" />,
  users: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.6a3.5 3.5 0 0 1 0 6.8M18.5 14.5a6.5 6.5 0 0 1 3 5.5" />
    </>
  ),
  rocket: (
    <>
      <path d="M5 15c-1.5 1.5-2 5-2 5s3.5-.5 5-2" />
      <path d="M9 15 6.5 12.5C8 8 11.5 4 20.5 3.5 20 12.5 16 16 11.5 17.5L9 15Z" />
      <circle cx="15" cy="9" r="1.5" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="M2.5 12h19M12 2.5c2.5 2.6 3.8 5.8 3.8 9.5s-1.3 6.9-3.8 9.5c-2.5-2.6-3.8-5.8-3.8-9.5S9.5 5.1 12 2.5Z" />
    </>
  ),
  cart: (
    <>
      <path d="M2.5 3.5h3l2.2 11.2a1.5 1.5 0 0 0 1.5 1.3h8.6a1.5 1.5 0 0 0 1.5-1.2L21 7.5H6.3" />
      <circle cx="9.5" cy="20" r="1.3" />
      <circle cx="17.5" cy="20" r="1.3" />
    </>
  ),
  lock: (
    <>
      <rect x="4" y="10.5" width="16" height="11" rx="2.5" />
      <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5M12 15v2.5" />
    </>
  ),
  gauge: (
    <>
      <path d="M3.5 17a9.5 9.5 0 1 1 17 0M12 14l4-5" />
      <circle cx="12" cy="14" r="1.3" />
    </>
  ),
  wrench: <path d="M14.5 6.5a4 4 0 0 0 5.2 5.2l-8.9 8.9a2.1 2.1 0 0 1-3-3l8.9-8.9a4 4 0 0 1-5.2-5.2l2.8 2.8 2.4-.6.6-2.4-2.8-2.8" />,
  apple: <path d="M16 3c0 1.7-1.3 3.5-3.2 3.5 0-1.8 1.4-3.4 3.2-3.5ZM12.3 8c1 0 2-.7 3.5-.7 1 0 2.6.5 3.6 2-3 1.8-2.4 6 .6 7.2-.7 1.8-2.2 4.5-3.9 4.5-1.3 0-1.6-.8-3.3-.8s-2.2.8-3.4.8C7.6 21 5 17 5 13.4 5 9.8 7.3 8 9.3 8c1.2 0 2.2.8 3 .8Z" />,
  android: (
    <>
      <path d="M5 11a7 7 0 0 1 14 0v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18v-7ZM5 12h14M7.5 5.5 6 3.5M16.5 5.5 18 3.5" />
      <circle cx="9.5" cy="8.5" r=".6" />
      <circle cx="14.5" cy="8.5" r=".6" />
    </>
  ),
  refresh: <path d="M20 11a8 8 0 0 0-14.6-4.5L3.5 9M3.5 4v5h5M4 13a8 8 0 0 0 14.6 4.5l1.9-2.5M20.5 20v-5h-5" />,
  palette: (
    <>
      <path d="M12 21.5a9.5 9.5 0 1 1 9.5-9.5c0 2.6-2.1 3.5-4 3.5h-2a2 2 0 0 0-1.5 3.3c.6.7.3 2.7-2 2.7Z" />
      <circle cx="7.5" cy="11" r="1" />
      <circle cx="10.5" cy="7" r="1" />
      <circle cx="15.5" cy="7.5" r="1" />
    </>
  ),
  server: (
    <>
      <rect x="3" y="3.5" width="18" height="7" rx="2" />
      <rect x="3" y="13.5" width="18" height="7" rx="2" />
      <path d="M7 7h.01M7 17h.01" />
    </>
  ),
  pipeline: (
    <>
      <circle cx="5" cy="6" r="2.5" />
      <circle cx="19" cy="18" r="2.5" />
      <path d="M5 8.5v3a3 3 0 0 0 3 3h8a3 3 0 0 1 3 3M11 3.5l2 2.5-2 2.5" />
    </>
  ),
  coins: (
    <>
      <ellipse cx="9" cy="6.5" rx="6" ry="3" />
      <path d="M3 6.5v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5M9 17.5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5c0-1.6-2.4-2.9-5.5-3" />
    </>
  ),
  activity: <path d="M2.5 12h4l3-8 5 16 3-8h4" />,
  map: <path d="M9 4 3 6.5v14L9 18l6 2.5 6-2.5V4l-6 2.5L9 4ZM9 4v14M15 6.5v14" />,
  building: <path d="M3 21h18M5 21V9l7-5 7 5v12M9 21v-5h6v5M9 11h.01M15 11h.01" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20.5 20.5-4.5-4.5" />
    </>
  ),
  book: <path d="M4 19V5a2.5 2.5 0 0 1 2.5-2.5H20v16H6.5A2.5 2.5 0 0 0 4 21a2.5 2.5 0 0 0 2.5 2H20" />,
  target: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <circle cx="12" cy="12" r="5.5" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
  mail: (
    <>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
      <path d="m3 6.5 9 6.5 9-6.5" />
    </>
  ),
  phone: <path d="M21 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.1 4.2 2 2 0 0 1 3.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9.5" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  check: <path d="m4.5 12.5 5 5 10-11" />,
  sparkles: <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" />,
  plus: <path d="M12 5v14M5 12h14" />,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  terminal: (
    <>
      <rect x="2.5" y="4" width="19" height="16" rx="2.5" />
      <path d="m7 9 3 3-3 3M12.5 15H17" />
    </>
  ),
};

const Icon = ({ name, size, className, strokeWidth = 1.6, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {paths[name]}
  </svg>
);

export default Icon;
